import {Component, OnInit, forwardRef, Input, ViewChild, ElementRef, Renderer2, AfterViewInit, Output, EventEmitter, OnChanges, SimpleChanges} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

const CUSTOM_VALUE_ACCESSOR = {
	provide: NG_VALUE_ACCESSOR,
	useExisting: forwardRef(() => CheckboxComponent),
	multi: true
};

@Component({
	selector: 'cp-checkbox',
	styleUrls: ['./checkbox.component.scss'],
	templateUrl: './checkbox.component.html',
	providers: [CUSTOM_VALUE_ACCESSOR]
})
export class CheckboxComponent implements OnInit, AfterViewInit, ControlValueAccessor {
	@ViewChild('input',{static:false}) inputElement: ElementRef;
	@Input() label;
	@Input() tabindex: number;
	@Input() disabled: boolean;
	@Input() indeterminate: boolean = false;

	@Output('focus') focusChange : EventEmitter<FocusEvent> = new EventEmitter<FocusEvent>();
	@Output('blur') blurChange : EventEmitter<FocusEvent> = new EventEmitter<FocusEvent>();
	@Output('click') clickChange : EventEmitter<FocusEvent> = new EventEmitter<FocusEvent>();


	public _value;
	public _id;

	constructor(protected renderer: Renderer2) { }

	ngOnInit() {
		this._id =  'checkbox_id_' + Math.floor((1 + Math.random()) * 0x10000)
				.toString(16)
				.substring(1);
	}

	ngAfterViewInit() {
		this.setValue(this._value);
	}

	focus() {
		this.inputElement.nativeElement.focus();
	}

	blur() {
		this.inputElement.nativeElement.blur();
	}

	writeValue(value: any): void {
		this._value = value;
		this.setValue(this._value);
	}

	setValue(value) {
		if (this.inputElement) {
			this.renderer.setProperty(this.inputElement.nativeElement, 'checked', value);
		}
	}

	onChange = (_) => { };
	onTouched = () => { };

	registerOnChange(fn) {
		this.onChange = fn;
	}

	registerOnTouched(fn) {
		this.onTouched = fn;
	}
}
